<article class="Notfound">
	<section class="Notfound__content">
		<p class="Notfound__paragraph Margin-bottom--z">¡Oh, algo salió mal!</p>
		<p class="Notfound__paragraph Margin-bottom--l">
			No encontramos la ruta a la que intentas ingresar
		</p>
		<app-button
			[isFull]="true"
			type="filled"
			(clicked)="goBack()">
			{{ buttonText() }}
		</app-button>
	</section>
</article>
